import type { PluginFunction } from '@kastjs/runtime-core';
import useFmp from './hooks/useFmp';

export const pathMap = new Map<number, string>();

export const customRadarEvent = (dimension: any, value?: object) => {
  if (
    window.performance &&
    window.performance.timing &&
    window.performance.timing.navigationStart
  ) {
    (window as any)?.PORTAL_GLOBAL_RADAR?.event(dimension, value);
  }
};

export interface Iprops {
  appId: number;
}

const Index: PluginFunction<Iprops> = async (context, options?) => {
  if (!options) return context;
  let hotStart: boolean = false;
  const { appSettings } = context;
  const { appId } = options;

  const enterTem = appSettings?.router?.onEnter;
  appSettings!.router!.onEnter = (to: any, from, history) => {
    // @ts-ignore
    enterTem && enterTem(to, from, history);
    if (to && to?.path) {
      if (hotStart && appId) {
        pathMap.set(appId, to?.path);
      } else {
        hotStart = true;
      }
    }
  };

  return context;
};

export default Index;
export { useFmp };
